import API, { apiErrorMessage } from "../global/api";

export const loginRequest = () => {
  window.localStorage.clear();
  return {
    type: "LOGIN_REQUEST",
  };
};
export const loginSuccess = (data) => {
  return {
    type: "LOGIN_SUCCESS",
    payload: data,
  };
};
export const loginError = (msg) => {
  return {
    type: "LOGIN_ERROR",
    payload: msg,
  };
};
export const login = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(loginRequest());
    API.post(`/auth/login`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(loginSuccess(data1));
        window.localStorage.setItem("token", data1.token);
        window.localStorage.setItem("isAuthenticated", "true");

        if (data1?.role === "admin") {
          window.location.replace("/main/admin-dashboard");
        } else {
          window.location.replace("/main");
        }

      })
      .catch((error) => {
        dispatch(loginError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

export const forgetPasswordRequest = () => {
  window.localStorage.clear();
  return {
    type: "FORGET_PASSWORD_REQUEST",
  };
};
export const forgetPasswordSuccess = (data) => {
  return {
    type: "FORGET_PASSWORD_SUCCESS",
    payload: data,
  };
};
export const forgetPasswordError = (msg) => {
  return {
    type: "FORGET_PASSWORD_ERROR",
    payload: msg,
  };
};
export const forgetPassword = (data, navigate, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(forgetPasswordRequest());
    API.post(`/user/forgotPassword`, data)
      .then((res) => {
        let forgetPasswordData = res.data;
        navigate("/create-new-password", { state: { id: forgetPasswordData?._id, email: data?.email } });
        dispatch(forgetPasswordSuccess(forgetPasswordData));
      })
      .catch((error) => {
        dispatch(forgetPasswordError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

export const resetPasswordRequest = () => {
  window.localStorage.clear();
  return {
    type: "RESET_PASSWORD_REQUEST",
  };
};
export const resetPasswordSuccess = (data) => {
  return {
    type: "RESET_PASSWORD_SUCCESS",
    payload: data,
  };
};
export const resetPasswordError = (msg) => {
  return {
    type: "RESET_PASSWORD_ERROR",
    payload: msg,
  };
};
export const resetPassword = (data, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(resetPasswordRequest());
    API.post(`/user/resetPassword`, data)
      .then((res) => {
        let resetPasswordData = res.data;
        dispatch(resetPasswordSuccess(resetPasswordData));
        handleVisible(resetPasswordData?.message, () => window.location.replace("/login"));
      })
      .catch((error) => {
        dispatch(resetPasswordError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};